// extracted by mini-css-extract-plugin
export var container = "AccountConnected-module__container___Dw2E5";
export var link = "AccountConnected-module__link___SYRgp";
export var text = "AccountConnected-module__text___ppMYn";